module.exports = __webpack_public_path__ + "static/media/tag@3x.eec8888a.png";